import { type VariantProps, cva } from 'class-variance-authority';
import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';

import { cn } from '../../utils';

const anchorVariants = cva(
  `text-surface underline-offset-4 hover:underline hover:text-surface-strong-hover active:text-surface-strong-active cursor-pointer`,
  {
    variants: {
      disabled: { true: `pointer-events-none text-disabled` },
    },
    defaultVariants: {
      disabled: false,
    },
  },
);

export interface AnchorProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof anchorVariants> {
  disabled?: boolean;
  asChild?: boolean;
}

const Anchor = React.forwardRef<HTMLAnchorElement, AnchorProps>(
  ({ asChild = false, className, disabled, ...props }, ref) => {
    const Comp = asChild ? Slot : 'a';
    return <Comp className={cn(anchorVariants({ disabled, className }))} ref={ref} {...props} />;
  },
);
Anchor.displayName = 'Anchor';

export { anchorVariants, Anchor };
